import React from "react";
import { useUser } from "./UserProvider";
import PhoneNumberDisplay from "./PhoneNumberDisplay";
import { useTranslation } from "react-i18next";

const ProfilePage = () => {
  const { user } = useUser();
  const { t } = useTranslation();

  if (!user) {
    return <p>...</p>;
  }

  return (
    <div>
      <div className="container mx-auto p-6">
        <div className="gap-6">
          <div className="col-span-1 bg-gray-100 p-4 rounded-lg shadow-md">
            <h2 className="text-xl font-bold mb-4">
              {t("accountInformation")}
            </h2>
            <ul className="space-y-3">
              <li>
                <strong>{t("email")}:</strong> {user.email}
              </li>
              <li>
                <strong>{t("phoneNumber")}:</strong>
                <PhoneNumberDisplay value={user.phone_number} />
              </li>
            </ul>

            {user.membership_type === "kurumsal" && (
              <div className="py-1">
                <ul>
                  <li>
                    <strong>{t("membershipType")}:</strong> {t("corporate")}
                  </li>
                  <li>
                    <strong>{t("companyTitle")}:</strong> {user.company_name}
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
